import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/axiosInstance";

const BlogAdmin = () => {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  const fetchBlogs = async () => {
    try {
      const res = await api.get("/api/blogs");
      setBlogs(res.data.data || []);
    } catch (err) {
      console.error("Failed to fetch blogs", err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const deleteBlog = async (id) => {
    if (!window.confirm("Delete this blog permanently?")) return;
    await api.delete(`/api/blogs/${id}`);
    fetchBlogs();
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Blogs</h1>

        <button
          onClick={() => navigate("new")}
          className="px-4 py-2 bg-primary text-white rounded"
        >
          + New Blog
        </button>
      </div>

      {blogs.length === 0 ? (
        <p className="text-muted-foreground">No blogs found.</p>
      ) : (
        <table className="w-full bg-card border rounded">
          <thead>
            <tr className="border-b bg-muted text-sm">
              <th className="p-3 text-left">Title</th>
              <th className="p-3 text-center">Status</th>
              <th className="p-3 text-center">Featured</th>
              <th className="p-3 text-center">Views</th>
              <th className="p-3 text-center">Created</th>
              <th className="p-3 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {blogs.map((blog) => (
              <tr key={blog._id} className="border-b text-sm">
                <td className="p-3 font-medium">{blog.title}</td>

                <td className="p-3 text-center">
                  {blog.isPublished ? (
                    <span className="text-green-600 font-medium">
                      Published
                    </span>
                  ) : (
                    <span className="text-yellow-600 font-medium">
                      Draft
                    </span>
                  )}
                </td>

                <td className="p-3 text-center">
                  {blog.isFeatured ? "⭐" : "-"}
                </td>

                <td className="p-3 text-center">{blog.views || 0}</td>

                <td className="p-3 text-center">
                  {new Date(blog.createdAt).toLocaleDateString()}
                </td>

                <td className="p-3 flex gap-4 justify-center">
                  <button
                    onClick={() => navigate(`/admin/blogs/edit/${blog._id}`)}
                    className="text-blue-600"
                  >
                    Edit
                  </button>

                  <button
                    onClick={() => deleteBlog(blog._id)}
                    className="text-red-600"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BlogAdmin;
